import type { Organization } from '@types';
import { COUNTRY_CODES } from '../common/data';

export type DashboardCountry = { name: string; iso2: string; iso3: string };

const countries = new Map<string, DashboardCountry>();

function key(value: string): string {
    return value.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

for (const [name, codes] of Object.entries(COUNTRY_CODES)) {
    const country = { name, iso2: codes.iso2, iso3: codes.iso3 };
    countries.set(key(name), country);
    countries.set(key(codes.iso2), country);
    countries.set(key(codes.iso3), country);
}

export function dashboardCountry(value: unknown): DashboardCountry | undefined {
    return countries.get(key(String(value || '')));
}

export function primaryRequestCountry(value: unknown): DashboardCountry | undefined {
    return dashboardCountry(String(value || '').split('\n', 1)[0].split('|', 1)[0]);
}

export function clientDashboardCountries(
    organization: Pick<Organization, 'headquartersAddress' | 'additionalLocations'>,
    deliveredCountries: string[] = []
): DashboardCountry[] {
    const locations = [organization.headquartersAddress, ...(organization.additionalLocations || [])];
    const found = new Map<string, DashboardCountry>();
    for (const location of locations) {
        const country = dashboardCountry(location?.country || location?.countryCode);
        if (country)
            found.set(country.iso3, country);
    }
    for (const name of deliveredCountries) {
        const country = dashboardCountry(name);
        if (country)
            found.set(country.iso3, country);
    }
    return [...found.values()];
}
